import queryString from "query-string";
import axios from "axios";
import { useEffect, useState } from "react";

const baseURL = process.env.REACT_APP_URL_CLIENT_LANDING;
const ProductDetailSection = ({ setActiveStep, getCartFromLocal }) => {
  const { product_id } = queryString.parse(window.location.search);
  const [data, setData] = useState({});
  const getCart = JSON.parse(window.localStorage.getItem("cart")) || [];

  const getProductDetail = async () => {
    const { data } = await axios.get(`${baseURL}/product/${product_id}`);

    if (data.data) {
      setData(data.data);
    }
  };

  useEffect(() => {
    getProductDetail();
  }, []);

  const findDuplicateProduct = () => {
    const result = getCart.find(
      (find) => find?.product_id === data?.product_id
    );

    if (result?.product_id) {
      return true;
    } else {
      return false;
    }
  };

  const btnAddCart = () => {
    if (getCart.length > 0) {
      const setStringify = JSON.stringify([
        ...getCart,
        {
          ...data,
          qty: 1,
        },
      ]);
      window.localStorage.setItem("cart", setStringify);
    } else {
      const setStringify = JSON.stringify([
        {
          ...data,
          qty: 1,
        },
      ]);
      window.localStorage.setItem("cart", setStringify);
    }
    setActiveStep(2);
    getCartFromLocal();
  };
  return (
    <div>
      <h2 className="text-center">Product Details</h2>

      <div className="container-content-product-detail mt-2 ">
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="row">
              <div className="col-12">
                <h3>Special Bundling 1</h3>
                <img
                  src="https://images.unsplash.com/photo-1617400120050-a1e45fa16c02?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3272&q=80"
                  alt=""
                  className="img-banner"
                  style={{ width: "100%", height: "300px", objectFit: "cover" }}
                />
                <div className="container-price mt-2">
                  <h4 className="price">Rp. 89.000.000</h4>
                  <small className="discount-price text-decoration-line-through">
                    <i>Rp. 120.000.000</i>
                  </small>
                </div>
                <div className="content-desc mt-1">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Praesentium, sint maiores consequuntur ullam nam, unde
                  voluptates facilis animi laborum incidunt aperiam, id saepe
                  eos ea. Quisquam, nemo! Dolorem possimus animi odit reiciendis
                  suscipit enim, molestias nam explicabo quibusdam fugit ad
                  labore. Aut, vero corporis maiores quidem sint totam inventore
                  magni?
                </div>
              </div>
              <div className="col-12">
                <h3 className="mt-5">Product Summary</h3>
                <div className="container-list-summary">
                  <span>1x 65 Gedung Online</span>
                  <span>1x internet support 100Mbps</span>
                  <span>6000x SMS LBA</span>
                </div>
                <strong>Only for</strong>
                <div className="container-price mt-2">
                  <h4 className="price">Rp. 89.000.000</h4>
                  <small className="discount-price text-decoration-line-through">
                    <i>Rp. 120.000.000</i>
                  </small>
                </div>
                <div className="mt-2">
                  {findDuplicateProduct() ? (
                    <button
                      className="btn button-primary"
                      onClick={() => setActiveStep(2)}
                    >
                      View To Cart
                    </button>
                  ) : (
                    <button className="btn button-primary" onClick={btnAddCart}>
                      Add To Cart
                    </button>
                  )}
                </div>
                <div className="mt-2">
                  <a href="/home" className="mt-2">
                    Back to Home
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="row">
              <div className="col-12">
                <h3>Product Item</h3>
              </div>
              {[2, 2, 2].map((item) => (
                <div className="col-12">
                  <div className="container-product-item mb-4">
                    <img
                      src="https://images.unsplash.com/photo-1617400120050-a1e45fa16c02?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3272&q=80"
                      alt=""
                      className="img-banner"
                      style={{
                        width: "100%",
                        height: "300px",
                        objectFit: "cover",
                      }}
                    />
                    <strong>1x 65 Gedung Online</strong>
                    <div className="content-desc mt-1">
                      Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                      Magnam doloribus architecto neque harum, sapiente vitae
                      commodi, assumenda iste accusantium excepturi voluptate
                      corporis recusandae. Quam nesciunt illum voluptatum
                      dolores rem eaque nam molestias temporibus quo voluptatem!
                      Optio inventore natus distinctio. Incidunt deleniti
                      accusamus numquam quisquam consequatur itaque consectetur
                      voluptatum atque, voluptatem quidem vero ut tempora
                      blanditiis similique voluptate asperiores. Eligendi
                      mollitia repellendus eaque, reiciendis eos officia debitis
                      necessitatibus atque ducimus laboriosam molestiae, ipsa
                      nobis? Qui rerum hic consectetur natus minima voluptas
                      veritatis. Adipisci expedita impedit modi beatae ex esse
                      qui nobis culpa, voluptatum numquam corporis porro neque
                      animi perspiciatis aliquid earum?
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailSection;
